import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import PhotoWall from "../components/PhotoWall";
import { useAuth } from "../context/AuthContext";
import { useProgress } from "../context/ProgressContext";

const PhotosPage = () => {
  const { user } = useAuth();
  const { children } = useProgress();
  return (
    <div className="bg-[#f7fdfe] min-h-[80vh] py-10 px-6" data-testid="photos-page">
      <div className="max-w-5xl mx-auto">
        <Link to="/family" className="inline-flex items-center gap-1 font-bold text-[#1b8bc9] hover:underline" data-testid="photos-back"><ChevronLeft size={16} /> Family dashboard</Link>
        <div className="mt-6 bg-white rounded-3xl shadow-md p-6 sm:p-8">
          {!user || children.length === 0 ? (
            <p className="text-gray-600" data-testid="photos-empty">Sign in as a parent with children in your family to see the photo wall.</p>
          ) : (
            <PhotoWall limit={0} showFilters embedded={false} />
          )}
        </div>
      </div>
    </div>
  );
};

export default PhotosPage;
